import { motion } from 'framer-motion';

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = '' }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: '-70px' }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ label, title, align = 'left' }) => (
  <Reveal className={align === 'center' ? 'text-center' : ''}>
    <p className="mono-label t-accent-text" data-testid={`label-${label.toLowerCase().replace(/\s+/g, '-')}`}>
      {label}
    </p>
    <h2 className="font-display t-text mt-4 text-3xl font-semibold leading-[1.1] tracking-tight sm:text-4xl lg:text-5xl">
      {title}
    </h2>
  </Reveal>
);

export { EASE };
